<template>
  <label
    class="ms-radio"
    @keypress="keyDownActive"
  >
    <input
      :model-value="modelValue"
      type="radio"
      :name="name"
      :value="keyValue"
      :checked="modelValue === keyValue"
      :tabindex="0"
      :disabled="disabled"
      @input="$emit('update:modelValue', keyValue)"
    >
    <span class="checkmark" />
    <span 
      v-if="label" 
      class="ms-radio--text"
    >{{ label }}</span>
  </label>
</template>
<script>
export default {
  name: 'MsRadio',
  props: {
    /**
     * Giá trị của radio được chọn
     */
    modelValue: {
      type: Number,
      default: 0,
    },
    label: {
      default: '',
      type: String,
    },
    /**
     * Giá trị mặc định của radio
     */
    keyValue: {
      type: Number,
      default: 0,
    },
    /**
     * Name của input radio
     */
    name: {
      default: '',
      type: String,
    },
    /**
     * Có disabled input không?
     */
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    /**
     * Xử lý khi ấn enter để chọn radio
     */
    keyDownActive(e) {
      e.preventDefault();
      switch (e.which) {
        case 32:
        case 13:
          this.$emit('update:modelValue', this.keyValue);
          this.$el.querySelector('input[type="radio"]').focus();
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsRadio.scss';
</style>
